import { ExportBasemap } from '~/client/src/shared/map/mapExportStyle'
import { UNITED_STATES } from '~/client/src/shared/stores/domain/WeatherForecasts.store'
import InitialState from '~/client/src/shared/stores/InitialState'

import type { IExportLiveMap } from './ExportPreview.store'
import { IMapExportEntry } from './MapExport.store'

// How a live map hands itself to the export: the Workflows map on desktop and on the phone, and Map
// Setup. Only a selected globe view exports. The label measurer draws on an OffscreenCanvas, which
// older iOS lacks.
export function createMapExportEntry(
  setUp: IExportLiveMap,
  state: InitialState,
  guard: (proceed: () => void) => void,
): IMapExportEntry {
  return {
    isAvailable: () => {
      const mbv = setUp.mapBoxViewerStore
      return (
        typeof OffscreenCanvas !== 'undefined' &&
        !!mbv.selectedGlobe &&
        !!mbv.mapRef &&
        mbv.isStyleLoaded
      )
    },
    guard,
    readSeed: () => {
      const mbv = setUp.mapBoxViewerStore
      const canvas = mbv.mapRef.getMap().getCanvas()
      const { projectAddress } = state
      return {
        projectId: state.activeProject?.id,
        viewCss: { width: canvas.clientWidth, height: canvas.clientHeight },
        basemap: mbv.isSatelliteActive
          ? ExportBasemap.Satellite
          : ExportBasemap.Street,
        layers: {
          workflowMarkups:
            mbv.markupPrefs.supportsWorkflowMarkups &&
            mbv.markupPrefs.showWorkflowMarkups,
          workflowLabels: !mbv.globeViewStyle.shouldHideWorkflowPinLabels,
          buildings3d: mbv.globeViewStyle.isThreeDEnabled,
        },
        markupLabelsVisible: mbv.markupPrefs.isWorkflowMarkupLabelsVisible,
        // The project's units rule, as the weather's: Imperial in the US or with no address.
        isMetricProject:
          !!projectAddress && projectAddress.country !== UNITED_STATES,
      }
    },
  }
}
